namespace GeniuzPOS.CustomReport {
    export interface ReportCusPromotionSaleRow {
        Id?: string;
        DateSale?: string;
        Category1?: string;
        Category2?: string;
        Category3?: string;
        NetSaleExVat?: number;
        PromoId?: string;
        PromoName?: string;
        PromoperiodFrom?: string;
        PromoperiodTo?: string;
        DateYear?: string;
        DateMonth?: string;
        SalesQty?: number;
        SkuCode?: string;
        PluCode?: string;
        ItemName?: string;
        SupplierCode?: string;
        SupplierName?: string;
        OnHandQty?: number;
    }

    export namespace ReportCusPromotionSaleRow {
        export const idProperty = 'Id';
        export const nameProperty = 'DateSale';
        export const localTextPrefix = 'CustomReport.ReportCusPromotionSale';
        export const deletePermission = '6CustomReport:Promotion Sale:View';
        export const insertPermission = '6CustomReport:Promotion Sale:View';
        export const readPermission = '6CustomReport:Promotion Sale:View';
        export const updatePermission = '6CustomReport:Promotion Sale:View';

        export declare const enum Fields {
            Id = "Id",
            DateSale = "DateSale",
            Category1 = "Category1",
            Category2 = "Category2",
            Category3 = "Category3",
            NetSaleExVat = "NetSaleExVat",
            PromoId = "PromoId",
            PromoName = "PromoName",
            PromoperiodFrom = "PromoperiodFrom",
            PromoperiodTo = "PromoperiodTo",
            DateYear = "DateYear",
            DateMonth = "DateMonth",
            SalesQty = "SalesQty",
            SkuCode = "SkuCode",
            PluCode = "PluCode",
            ItemName = "ItemName",
            SupplierCode = "SupplierCode",
            SupplierName = "SupplierName",
            OnHandQty = "OnHandQty"
        }
    }
}
